import { useAppSelector } from '../../../app/hooks';

const useFilterInstitutionsInitialState = () => {
  const { filterOptions } = useAppSelector(( state ) => state.institution );

  return {
    active: filterOptions ? filterOptions.active : null,
    from: filterOptions ? filterOptions.from : null,
    until: filterOptions ? filterOptions.until : null,
  };
};

export default useFilterInstitutionsInitialState;
